import React, { useState, useEffect, useCallback, useRef } from 'react';
import axios from 'axios';
import moment from 'moment';
import { CSVLink } from "react-csv";
import constClass from '../../Constants/Constants';
import { useToasts } from 'react-toast-notifications';
import CommonBooking from '../Common/common_booking';

const BookingCsv = (props) => {
  const [lockData, setLockData] = useState(false);
  const [bookingData, setBookingData] = useState(null);
  const [startDate, setStartDate] = useState(moment().startOf('month').format('YYYY-MM-DD'));
  const [endDate, setEndDate] = useState(moment().endOf('month').format('YYYY-MM-DD'));
  const [csvData, setCsvData] = useState(null);
  const [shoplist, setShoplist] = useState(null);
  const [talkCategoryList, setTalkCategoryList] = useState(null);
  const { addToast } = useToasts();
  const csvRef = useRef();
  const [shop, setShop] = useState('');

  const refreshBook = useCallback(async () => {
    const jwt = localStorage.getItem('jwt');
    const sp = (await axios.post(`${process.env.REACT_APP_BACKEND_URL}/shop/search`, {
      site_id: props.siteId,
      operator: "and",
      where: [{ site_id: props.siteId }]
    }, { headers: { Authorization: `Bearer ${jwt}` } })).data;
    setShoplist(sp);
    // setShop(props.user.shopId);

    // 予約の目的一覧を取得する
    const talk_category = (await axios.post(`${process.env.REACT_APP_BACKEND_URL}/talk_category/search`, {
      site_id: props.siteId,
      operator: "and",
      where: [{ site_id: props.siteId }]
    })).data;
    setTalkCategoryList(talk_category);
  }, [props.siteId]);

  const changeSelectShop = (data) => {
    setShop(data.target.value === '' ? '' : Number(data.target.value))
  }

  const BookingSearch = async () => {
    setLockData(true);
    const jwt = localStorage.getItem('jwt');
    const reg_params = {
      "operator": "and",
      "where": [
        {
          "operator": "gte",
          "attr": "book_date",
          "val": moment(startDate).format('YYYY-MM-DD')
        },
        {
          "operator": "lte",
          "attr": "book_date",
          "val": moment(endDate).format('YYYY-MM-DD')
        },
        {
          "operator": "eq",
          "attr": "site_id",
          "val": props.siteId
        },
      ]
    };
    if (shop !== '') {
      reg_params.where.push({
        "operator": "eq",
        "attr": "shop_id",
        "val": shop
      });
    }

    // DB取得
    const booking_data = (await axios.post(`${process.env.REACT_APP_BACKEND_URL}/booking/search/`, reg_params, {
      headers: {
        Authorization: `Bearer ${jwt}`,
      }
    })).data;

    booking_data.sort((a, b) => a.book_date > b.book_date ? 1 : (a.book_date === b.book_date && a.book_id > b.book_id) ? 1 : (a.book_date === b.book_date && a.book_id === b.book_id && a.book_set_id > b.book_set_id) ? 1 : -1);
    //console.log(booking_data);
    setBookingData(booking_data);
    CreateCsvData(booking_data);
    setLockData(false);
  }

  // ChangeCell
  const dateChange = (event) => {
    // 開始日
    if (event.target.name === "book_date_start") {
      setStartDate(event.target.value);

      // 終了日
    } else if (event.target.name === "book_date_end") {
      setEndDate(event.target.value);
    }
  }

  // CSVset（予約データ）
  const CreateCsvData = (data) => {
    var list = [];
    var head = [];
    head.push({ label: "受付番号", key: "receipt_num" });
    head.push({ label: "項番", key: "book_id" });
    head.push({ label: "枝番", key: "book_set_id" });
    head.push({ label: "LINEユーザID", key: "line_id" });
    head.push({ label: "カテゴリID", key: "category_id" });
    head.push({ label: "カテゴリ名", key: "category_name" });
    head.push({ label: "支所", key: "shop_name" });
    head.push({ label: "会員番号", key: "card_id" });
    head.push({ label: "予約の目的", key: "talk_category_name" });
    // head.push({ label: "予約の目的詳細", key: "talktext" });
    head.push({ label: "予約日", key: "book_date" });
    head.push({ label: "開始時刻", key: "start_time" });
    head.push({ label: "終了時刻", key: "end_time" });
    head.push({ label: "担当職員", key: "staff_name" });
    head.push({ label: "税抜き単価", key: "price_before_tax" });
    head.push({ label: "税込み単価", key: "price" });
    head.push({ label: "税率", key: "tax_rate" });
    head.push({ label: "数量", key: "count" });
    head.push({ label: "備考", key: "remarks" });
    head.push({ label: "利用者ID", key: "customer_id" });
    head.push({ label: "お名前", key: "customer_name" });
    head.push({ label: "お名前(カナ)", key: "customer_kana" });
    head.push({ label: "性別", key: "customer_gender" });
    head.push({ label: "決済手段", key: "payment_type" });
    head.push({ label: "決済手段", key: "payment_type_name" });
    head.push({ label: "状態", key: "status" });
    head.push({ label: "予約日時", key: "ins_date" });
    data.forEach(p => {
      var booking = {
        receipt_num: p.t_booking.receipt_num,
        book_id: p.book_id,
        book_set_id: p.book_set_id,
        line_id: p.t_booking.line_id,
        category_id: p.category_id,
        shop_name: shoplist ? shoplist.find(s => s.shop_id === p.shop_id)?.shop_name : '',
        card_id: p.card_id ? p.card_id : '',
        talk_category_name: talkCategoryList ? talkCategoryList.find(t => t.talk_id === p.talk_id)?.talk : '',
        // talktext: p.talktext ? p.talktext.replace(/"/g, '""') : '',
        category_name: p.category_name,
        book_date: moment(p.book_date).format("YYYY/MM/DD"),
        start_time: CommonBooking.strTotime(p.start_time),
        end_time: CommonBooking.strTotime(p.end_time),
        staff_name: p.staff_name ? p.staff_name.replace(/"/g, '""') : '',
        price_before_tax: p.price_before_tax,
        price: p.price,
        tax_rate: p.tax_rate,
        count: p.count,
        remarks: p.remarks,
        customer_id: p.customer_id,
        customer_name: p.customer_name ? p.customer_name.replace(/"/g, '""') : '',
        customer_kana: p.customer_kana ? p.customer_kana.replace(/"/g, '""') : '',
        customer_gender: p.customer_gender,
        payment_type: p.payment_type,
        payment_type_name: p.payment_type ? constClass.PAYMENT_TYPE_NAME_CSV[p.payment_type] : '',
        status: constClass.STATUS_NAME_CSV[p.booking_status],
        ins_date: moment(p.ins_date).format("YYYY/MM/DD HH:mm:ss"),
      };
      list.push(booking);
    });
    setCsvData({ header: head, list: list });
  }

  const handleExportClick = async () => {
    const jwt = localStorage.getItem('jwt');
    const params = {
      site_id: props.siteId,
      command: 'booking_csv_export',
      book_id: csvData.list.map(b => b.book_id)
    }
    try {
      setLockData(true);
      await axios.post(`${process.env.REACT_APP_BACKEND_URL}/log/`, params, {
        headers: {
          Authorization: `Bearer ${jwt}`
        }
      });

      csvRef.current.link.click();
    } catch (err) {
      if (err.response.data !== null) {
        addToast(err.response.data.msg, { appearance: 'error', autoDismiss: true });
      } else {
        addToast(err.response, { appearance: 'error', autoDismiss: true });
      }
    } finally {
      setLockData(false);
    }
  }

  useEffect(() => {
    refreshBook();
  }, [refreshBook]);


  // 検索ボタン
  const searchButton = () => {
    return (
      <button type="button"
        disabled={lockData || !startDate || !endDate}
        className={`btn btn-primary`}
        onClick={() => BookingSearch()}>
        検索
      </button>
    )
  }

  return (
    <div className="container">

      {/* 開始日・終了日入力フォーム */}
      <div className="row mb-3 p-0">
        <div className="col-6 row">
          <div className="pe-2 col-auto">
            <div className="d-flex align-items-center justify-content-end pt-2">
              予約日：
            </div>
          </div>
          <div className="col-4 pe-2">
            <div className="csv-input">
              <input type="date" className="form-control" id={"book_date_start"} name={"book_date_start"} value={moment(startDate).format('YYYY-MM-DD')} onChange={dateChange}></input>
            </div>
          </div>
          <div className="col-1 px-3">
            <div className="d-flex align-items-center justify-content-center pt-2">
              ～
            </div>
          </div>
          <div className="col-4 pe-2">
            <div>
              <input type="date" className="form-control" id={"book_date_end"} name={"book_date_end"} value={moment(endDate).format('YYYY-MM-DD')} onChange={dateChange}></input>
            </div>
          </div>
        </div>

        <div className="col-4 row">
          <div className="col-auto pe-2">
            <div className="d-flex align-items-center justify-content-end pt-2">
              支所:
            </div>
          </div>
          {shoplist && (
            <div className="col">
              <select className="custom-select text-center w-100"
                value={shop}
                onChange={changeSelectShop}
              >
                <option value="" >- 選択 -</option>
                {shoplist.map((item, idx) =>
                  <option key={idx} value={item.shop_id}>{item.shop_name}</option>
                )}
              </select>
            </div>
          )}
        </div>

        {/* 検索ボタン */}
        <div className="col-2">
          <div className="col-sm-12">
            {searchButton()}
          </div>
        </div>
      </div>

      {/* 件数出力 */}
      {bookingData !== null && (
        <div className="row mb-3 p-0">
          <div className="col-11 p-0 d-flex align-items-center justify-content-center ">
            <table className="table table-bordered table-striped w-50">
              <thead className={`table-info`}>
                <tr>
                  <td className="text-center">
                    検索件数
                  </td>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td className="text-center">
                    {bookingData ? bookingData.length : ''}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      )}

      <div className="row btn-toolbar">
        <div className="btn-group col-11">
          <div className="offset-4 col-4">
            {csvData !== null && (
              <React.Fragment>
                <button
                  className="btn btn-primary print-none mb-1 px-0 w-100"
                  disabled={lockData}
                  onClick={() => handleExportClick()}>
                  予約データ出力
                </button>
                <CSVLink className="d-none" data={csvData.list} headers={csvData.header} filename={"予約データ.csv"} ref={csvRef} />
              </React.Fragment>
            )}
          </div>
        </div>
      </div>

    </div>
  )
}

export default BookingCsv